import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Status from 'components/field/Status';
import Modal from 'components/global/Modal';
import NoRecordsFound from 'components/global/NoRecordsFound';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useLocale from 'hooks/useLocale';

import { ORDER_ACTIONS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const StatusChangeHistoryModal = NiceModal.create(({ otoOrderId }) => {
	const { t } = useTranslation();
	const { getLocaleDateWithTime } = useLocale();
	const axiosPrivate = useAxiosPrivate();
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const fetchOrderStatuses = async () => {
			setIsLoading(true);
			try {
				const response = await axiosPrivate.post(ORDER_ACTIONS.GET_DC_STATUS_HISTORY, {
					id: otoOrderId
				});
				if (response.status === 200) {
					setData(response.data);
				}
			} catch (error) {
				AppLogger.error(error);
			} finally {
				setIsLoading(false);
			}
		};
		fetchOrderStatuses();
	}, [otoOrderId]);

	const columns = useMemo(
		() => [
			{
				header: 'dcStatus',
				accessorKey: 'dcStatus',
				showOnMobile: true
			},
			{
				header: 'otoStatus',
				accessorKey: 'otoStatus',
				size: 200,
				renderCell: ({ row }) => <>{row.original.otoStatus ? <Status value={row.original.otoStatus} /> : ''}</>,
				showOnMobile: true
			},
			{
				header: 'dcDescription',
				accessorKey: 'dcDescription',
				showOnMobile: true
			},
			{
				header: 'webhookSearchMethod',
				accessorKey: 'webhookSearchMethod',
				showOnMobile: true
			},
			{
				header: 'dcUpdateDate',
				accessorKey: 'dcUpdateDate',
				renderCell: ({ row }) => <Typography>{getLocaleDateWithTime(row.original.dcUpdateDate)}</Typography>,
				showOnMobile: true
			},
			{
				header: 'updateStatusDate',
				accessorKey: 'updateStatusDate',
				showOnMobile: true
			},
			{
				header: 'shipmentId',
				accessorKey: 'shipmentId',
				showOnMobile: true
			},
			{
				header: 'trackingNumber',
				accessorKey: 'trackingNumber',
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<Modal maxWidth="x-large" fullwidth className="modal-orderStatuses">
			<ModalTitle>
				<Typography variant="p1">
					{t('statusHistory')} (<strong>{otoOrderId}</strong>)
				</Typography>
			</ModalTitle>
			<ModalContent>
				<Table
					columns={columns}
					data={data}
					loading={isLoading}
					noRecordsFound={
						<NoRecordsFound
							lottieName="no-history"
							height="10rem"
							title="noStatus"
							subTitle="noStatusesInThisOrder"
						/>
					}
				/>
			</ModalContent>
		</Modal>
	);
});

export default StatusChangeHistoryModal;
